<template>
  <AllProductList />
</template>

<script>
import AllProductList from './AllProductList'
export default {
  name: 'AllProductView',
  components: {
    AllProductList
  },
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/all_products/AllProductView.vue